import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';

export type OnboardingEntityTableName = 'onboardings' | 'users';

export type PreparedOnboardingData = {
    record: Model;
    table: OnboardingEntityTableName;
    operation: ValidationOperation;
};

export const mapRecord = (
    record: Model,
    table: OnboardingEntityTableName,
    operation: ValidationOperation,
): PreparedOnboardingData => ({
    record,
    table,
    operation,
});

export const addPreparedDataBatch = async (
    preparedData: PreparedOnboardingData[],
    database: Database,
) => {
    await database.batch(...preparedData.map(({ record }) => record));
};
